import * as React from 'react';
import OCButton from '@cx-web/components/primitives/button';
import Icon from '@cx-web/components/primitives/icon';
import { useBetslipContext } from '@cx-web/feature-betslip/context';
// providers
import { useLabelActions } from '@cx-web/feature-i18n';
// services
import { buildBetOnBookmakerSiteEvent, trackBetslipEvent } from '@cx-web/feature-tracking/betslip';

// hooks
// styles
import styles from '../style/betslip.module.css';

const ButtonSection = () => {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);

  const labelActions = useLabelActions();
  const { count: numberOfBets, handleClearBetslip, handleClickoutToPlaceBet, selectedBookie } = useBetslipContext();

  if (!mounted) return null;

  if (numberOfBets === 0) {
    return null;
  }

  return (
    <div className={styles.buttonSection}>
      <OCButton className={styles.button} onClick={handleClearBetslip} type="primary">
        {labelActions.get('DELETE_ALL')}
      </OCButton>
      <OCButton
        className={styles.button}
        onClick={() => {
          trackBetslipEvent(buildBetOnBookmakerSiteEvent(selectedBookie?.bookmakerCode));
          handleClickoutToPlaceBet();
        }}
        type="secondary"
      >
        <Icon height={16} icon="Clickout" width={16} />
        {labelActions.get('BET_ON_BOOKMAKER_WEBSITE')}
      </OCButton>
    </div>
  );
};

export default ButtonSection;
